module.exports = __webpack_public_path__ + "static/award-fdm-video-editor-275de56f5285a9003d61ba5c005811c9.png";